@if (config && show) {
  <div @state class="wrapper" [ngClass]="config.className">
    <ui-feedback-header
      [title]="config.title"
      [buttonText]="config.buttonText"
      [state]="config.state"
      [translationParams]="config.translationParams"
      [icon]="icon"
      [shouldMaskPii]="config.shouldMaskPii"
      (handleAction)="onButtonClick()"
    />
    <ui-feedback-progress-bar [showAnimation]="true" [duration]="duration" [state]="config.state" />
  </div>
}
